// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2JaR6","contentWrapper":"_1bKo-","notFoundHeading":"_2ZmdJ","notFoundText":"Nkelk"};